import { render, staticRenderFns } from "./schoolManager.vue?vue&type=template&id=27ea928a&scoped=true&"
import script from "./schoolManager.vue?vue&type=script&lang=js&"
export * from "./schoolManager.vue?vue&type=script&lang=js&"
import style0 from "./schoolManager.vue?vue&type=style&index=0&id=27ea928a&prod&lang=css&"
import style1 from "./schoolManager.vue?vue&type=style&index=1&id=27ea928a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea928a",
  null
  
)

export default component.exports